import React from 'react';
import { img_path} from '../../../environment';
import OptimizedImage from '../../../components/OptimizedImage';

interface Image {
  className?: string;
  src: string;
  alt?: string;
  height?: number;
  width?: number;
  id?:string;
}

const ImageWithBasePath = (props: Image) => {
  // Combine the base path and the provided src to create the full image source URL
  const fullSrc = `${img_path}${props.src}`;
  
  return (
    <OptimizedImage
      src={fullSrc}
      alt={props.alt || ""}
      className={props.className}
      width={props.width}
      height={props.height}
      id={props.id}
      lazy={true}
      fallback="/assets/img/avatar.png"
    />
  );
};

export default ImageWithBasePath;
